import React from 'react';
import { integrationsWithLogos } from './Integrations';
import RevenueRingFloat from './RevenueRingFloat';
import WhatsAppHeroPhone from './WhatsAppHeroPhone';

/** Desktop / tablet (sm+): phone with floating rails. Shown only from `sm` breakpoint via parent. */
export default function WhatsAppHeroVisual() {
  return (
    <div className="mx-auto w-full max-w-[min(100%,1040px)] py-4 sm:py-8 flex justify-center px-3 sm:px-6">
      {/* Side by side: floats sit beside the phone, not over the glass; negative margin tucks them onto the bezel */}
      <div className="flex flex-row items-stretch justify-center">
        <aside className="flex flex-col justify-between shrink-0 w-[272px] md:w-[292px] lg:w-[300px] pr-0 -mr-4 md:-mr-6 pointer-events-none z-20 py-3 md:py-5">
          <div className="w-full max-w-[15rem] ml-auto rounded-full bg-white shadow-[0_18px_40px_-6px_rgba(0,0,0,0.2)] border border-gray-100 px-3 py-2.5 flex items-center gap-2.5">
            <img src="/avatar7.png" alt="" className="w-10 h-10 md:w-11 md:h-11 rounded-full object-cover border-2 border-white shadow shrink-0" />
            <p className="text-[11px] md:text-[12px] text-gray-900 leading-snug">
              <span className="font-bold text-emerald-600">Purchased $20k</span>
              <span className="text-gray-400">, </span>
              <span className="text-gray-700">Win back, Shopify</span>
            </p>
          </div>
          <div className="ml-auto flex w-max max-w-none flex-nowrap items-center justify-end gap-2 sm:gap-2.5 rounded-full bg-white/95 backdrop-blur-sm shadow-[0_14px_32px_-6px_rgba(0,0,0,0.18)] border border-gray-100 px-3 py-2.5 sm:px-3.5 sm:py-3">
            {integrationsWithLogos.map((integration) => (
              <div
                key={integration.name}
                className="flex h-9 w-9 sm:h-10 sm:w-10 md:h-11 md:w-11 items-center justify-center rounded-full bg-gray-50 border border-gray-100 overflow-hidden shrink-0"
                title={integration.title}
              >
                <img
                  src={integration.image}
                  alt={integration.alt}
                  className="max-h-[22px] max-w-[22px] sm:max-h-6 sm:max-w-6 md:max-h-7 md:max-w-7 object-contain"
                />
              </div>
            ))}
          </div>
        </aside>

        <div className="relative z-10 w-[min(100%,292px)] sm:w-[308px] md:w-[324px] lg:w-[338px] shrink-0 select-none mx-auto sm:mx-0">
          <WhatsAppHeroPhone className="h-[652px] sm:h-[678px] md:h-[698px] lg:h-[718px] max-h-[min(88vh,760px)]" />
        </div>

        <aside className="flex flex-col justify-start shrink-0 w-[96px] md:w-[108px] pl-0 -ml-2 md:-ml-3 pointer-events-none z-20 pt-10 md:pt-12 lg:pt-14 translate-x-2 md:translate-x-3">
          <RevenueRingFloat />
        </aside>
      </div>
    </div>
  );
}
